import { render, staticRenderFns } from "./ContactFacturesList.vue?vue&type=template&id=04d5994f"
import script from "./ContactFacturesList.vue?vue&type=script&lang=ts"
export * from "./ContactFacturesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports